import { VisionLinkFooterImageProps } from '../../types';
import classNames from 'classnames';
import { VisionLinkExternalLink } from '../VisionLinkExternalLink';


export const VisionLinkFooterImage = ({
  image,
  label,
  imgClassname = ''
}: VisionLinkFooterImageProps) => {
  return (
    <div className="d-flex align-items-center mb-1 mb-md-0">
      <VisionLinkExternalLink >
        <span>{label}</span>
      </VisionLinkExternalLink>
      <img
        className={classNames('ms-1', imgClassname)}
        src={image?.url}
        alt={image?.alt}
        loading="lazy"
      />
    </div>
  );
};
